import { AxiosInstance, InternalAxiosRequestConfig } from 'axios';
import { store } from 'src/infra/stores/store';

const API_VERSION_KEY = 'apiVersion';

/**
 * Attaches the API version to every API request
 * Adds the 'x-api-version' header with the selected version (1 or 2)
 * When API_VERSION_SWITCH is disabled, uses the default version from environment config
 * When API_VERSION_SWITCH is enabled, uses the user-selected version from Redux store
 */
export const attachApiVersionInterceptor = (axiosInstance: AxiosInstance) => {
  axiosInstance.interceptors.request.use(async (config: InternalAxiosRequestConfig) => {
    const state = store.getState();
    const useV2 = state[API_VERSION_KEY]?.useV2 ?? false;

    if (!useV2) {
      return config;
    }

    config.headers['x-api-version'] = '2';

    return config;
  });
};
